import type { Distance } from "@pdfking/math"
import { Total } from "@pdfking/math"
import type { PageShape } from "@pdfking/renderer-api"
import { DrawPath, PlotFunction } from "@pdfking/renderer-api"

import { LINE_STROKE, PALETTE } from "#constants"

/** A line from (x, y) `width` across or `height` up, its middle on them, in
 * the lines' gray and `stroke` wide: every line a page is ruled with */
export const PlotLine = (
  x: Distance,
  y: Distance,
  width: Distance,
  height: Distance,
  stroke: Distance = LINE_STROKE
): PageShape => ({
  enum: PlotFunction.PLOT_PATH,
  points: DrawPath([
    { x, y },
    { x: Total(x, width), y: Total(y, height) },
  ]),
  stroke_color: PALETTE.lines,
  stroke_width: stroke,
})
